<template>
  <router-view></router-view>
</template>

<style lang="less" scoped>
</style>
